module.exports = __webpack_public_path__ + "img/tmb_ch_settra_0.3c1d6a30.png";